import { SVGAttributes } from 'react'

const UserIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M17 15.9375C17 12.3931 10.625 13.1069 10.625 10.2681C10.625 10.2681 12.75 8.14307 12.75 4.25C12.75 1.90918 10.8408 0 8.5 0C6.15918 0 4.25 1.90918 4.25 4.25C4.25 8.14307 6.375 10.2681 6.375 10.2681C6.375 13.1069 0 12.3931 0 15.9375V16.6431C0 16.8423 0.157715 17 0.356934 17H16.6431C16.8423 17 17 16.8423 17 16.6431V15.9375Z" />
    </svg>
)
export default UserIcon
